import { useCallback } from "react";

import { styled } from "@linaria/react";

import FlexWrapper, { FlexDirection } from "@gx/dls/containers/FlexWrapper";
import TextAreaInput, { TextAreaVariant } from "@gx/dls/inputs/TextAreaInput";
import { withTheme, type PropsWithTheme } from "@gx/dls/theme";
import { ProjectMappingMethod } from "@gx/ts-contracts/services/project/resources/project_configuration/project_configuration_pb";

import { CreateProjectFormActionType } from "@/pages/projects/forms/create/actions";
import MappingMethodCard from "@/pages/projects/forms/create/components/steps/select-mapping-method/components/MappingMethodCard";
import { useCreateProjectFormContext } from "@/pages/projects/forms/create/hooks";

const MappingMethodAutoIntrospectWrapper = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;

const CardContainer = styled.div`
  flex: 0 0 400px;
  min-width: 400px;
`;

const TextAreaContainer = withTheme(styled.div<PropsWithTheme>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`);

const MappingMethodAutoIntrospect = () => {
  const { state, dispatch } = useCreateProjectFormContext();

  const handlePromptChange = useCallback(
    (value: string) => {
      dispatch({
        type: CreateProjectFormActionType.SET_AUTO_INTROSPECT_PROMPT,
        payload: value,
      });
    },
    [dispatch],
  );

  const handleSelect = useCallback(() => {
    dispatch({
      type: CreateProjectFormActionType.SET_SELECTED_MAPPING_METHOD,
      payload: ProjectMappingMethod.AUTO,
    });
  }, [dispatch]);

  return (
    <MappingMethodAutoIntrospectWrapper>
      <CardContainer>
        <MappingMethodCard
          method={ProjectMappingMethod.AUTO}
          isSelected={state.selectedMappingMethod === ProjectMappingMethod.AUTO}
          onSelect={handleSelect}
        />
      </CardContainer>
      <TextAreaContainer>
        <FlexWrapper direction={FlexDirection.COLUMN} gap={8} fillWidth fillHeight>
          <TextAreaInput
            value={state.autoIntrospectPrompt}
            label="Additional context"
            labelTooltip="Use this to help our agents understand the context graph you want to build"
            placeholder="Enter additional context here"
            onChange={handlePromptChange}
            variant={TextAreaVariant.PRIMARY}
            fillWidth
            fillHeight
            lines={6}
          />
        </FlexWrapper>
      </TextAreaContainer>
    </MappingMethodAutoIntrospectWrapper>
  );
};

export default MappingMethodAutoIntrospect;
